import { Button, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: theme.borderRadius.small,
    padding: ({ size }) => (size === 'default' ? 12 : 10),
    border: `1px solid ${theme.colors.brandIcon}`,
    color: theme.colors.brandAction,
    minWidth: '0px',

    '&:hover': {
      backgroundColor: theme.colors.brandBg,
    },

    '& svg': {
      width: ({ size }) => (size === 'default' ? 16 : 12),
      height: ({ size }) => (size === 'default' ? 16 : 12),
      fill: theme.colors.brandAction,
    },
  },

  sizeSmall: {
    padding: '10px',
  },

  label: {
    lineHeight: 1,
  },
}));

function IconButton({ className, children = null, size = 'default', onClick, style }) {
  const classes = useStyles({ size });
  return (
    <Button
      className={className}
      classes={classes}
      disableRipple
      variant="outlined"
      size={size === 'default' ? 'medium' : size}
      onClick={onClick}
      style={style}
    >
      {children}
    </Button>
  );
}

IconButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.oneOf(['default', 'small']),
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default IconButton;
